<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="30%"
    title="修改密码">
    <el-input v-model="params.Password" type="password" placeholder="请输入">
      <template slot="prepend">旧密码</template>
    </el-input>
    <el-input v-model="params.NewPassword" type="password" placeholder="请输入">
      <template slot="prepend">新密码</template>
    </el-input>
    <el-input v-model="params.confirmpwd" type="password" placeholder="请输入">
      <template slot="prepend">确认新密码</template>
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { SuccessNotify, WarningMessage } from '@/utils/utils'

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      params: {
        Password: '',
        NewPassword: '',
        confirmpwd: ''
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.isShow
      },
      set(val) {
        this.$emit('update:isShow', val)
      }
    }
  },
  methods: {
    handleConfirm() {
      if (this.params.NewPassword !== this.params.confirmpwd) {
        WarningMessage(this, '两次输入的密码不一致')
      }
      this.$store.dispatch('UpdateAdminUserPassword', this.params).then(() => {
        this.dialogVisible = false
        SuccessNotify(this, '修改成功')
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/change-password.vue